import React from 'react'
import Switch from '@material-ui/core/Switch'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  switchWrapper: {
    width: '73px',
    textAlign: 'center',
    '& > span, & > span > span:first-child': {
      height: '38px'
    }
  }
})

const TableCell = React.memo(props => {
  const { classes, type, functionality, checked, onChange, readOnly } = props

  const canDisplay = () => {
    switch (true) {
      case /logConteudos|exportConteudos|logInteracoes/.test(functionality.alias) &&
        ['editar', 'remover'].includes(type):
        return false
      case /avaliacoes/.test(functionality.alias) && 'remover' === type:
        return false
      default:
        return true
    }
  }

  return (
    <td className={classes.switchWrapper}>
      {canDisplay() && (
        <Switch
          checked={checked}
          onChange={onChange}
          value={`${functionality.alias}-${type}`}
          color="primary"
          disabled={readOnly}
        />
      )}
    </td>
  )
})

export default withStyles(styles)(TableCell)



// WEBPACK FOOTER //
// ./src/components/PermissionsTable/TableCell.js